import styled from "styled-components";

export const ProductList = styled.main`
  & > div {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px 10px;

    @media (max-width: 599px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 400px) {
      grid-template-columns: 1fr;
    }
  }

  h1 {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 24px;
    color: #222;
    margin-bottom: 40px;
  }
`;
